<template>
  <div>
    <b-modal
      ref="modal-inserir-usuario"
      id="modal_inserir_usuario"
      :title="titulo"
      hide-footer
      no-stacking
      no-close-on-backdrop
    >
      <form @submit.prevent="criarUsuario">
        <div class="form-check md-form form-sm">
          <input
            type="checkbox"
            id="comprador"
            class="form-check-input validate"
            v-model="payload.comprador"
          />
          <b>&nbsp;&nbsp;&nbsp; SOU COMPRADOR</b><br />(mercados, restaurantes,
          hotéis, prefeituras, etc)<br /><br />
        </div>

        <div class="form-check md-form form-sm">
          <input
            type="checkbox"
            id="produtor"
            class="form-check-input validate"
            @change="changeProdutor"
            v-model="payload.produtor"
          />
          <b>&nbsp;&nbsp;&nbsp;SOU PRODUTOR / AGROINDÚSTRIA</b><br /><br />
        </div>

        <div class="form-check md-form form-sm">
          <input
            type="checkbox"
            id="outros"
            class="form-check-input validate"
            v-model="payload.outros"
          />
          <b>&nbsp;&nbsp;&nbsp;OUTRO PERFIL</b><br /><br />
        </div>

        <div class="md-form form-sm">
          <label data-error="wrong" data-success="right" for="nome"
            >Nome Completo:</label
          >
          <input
            type="text"
            id="nome"
            class="form-control form-control-sm validate"
            v-model="payload.nome"
            required
          />
        </div>
        <div class="md-form form-sm">
          <label data-error="wrong" data-success="right" for="nascimento"
            >Data de Nascimento:</label
          >
          <input
            type="text"
            id="nascimento"
            class="form-control form-control-sm validate"
            v-mask="'##/##/####'"
            v-model="payload.nascimentoString"
            pattern="(0[1-9]|1[0-9]|2[0-9]|3[01])/(0[1-9]|1[012])/[0-9]{4}"
            required
          />
        </div>
        <div class="md-form form-sm">
          <label data-error="wrong" data-success="right" for="cpf">CPF:</label>
          <input
            type="text"
            id="cpf"
            class="form-control form-control-sm validate"
            v-model="payload.CPF"
            v-mask="'###.###.###-##'"
            @blur="existeCPFCadastrado()"
            required
          />
        </div>

        <div v-if="existeCPF" class="text-center form-sm mt-2">
          <span
            ><b style="color: red"
              >Já existe um usuário com este CPF cadastrado</b
            ></span
          >
        </div>

        <div class="md-form form-sm">
          <label data-error="wrong" data-success="right" for="telefone"
            >Telefone celular com DDD:</label
          >
          <input
            type="text"
            id="telefone"
            class="form-control form-control-sm validate"
            v-model="payload.telefone"
            v-mask="'(##) #####-####'"
            @blur="existeTelefoneCadastrado()"
            required
          />
        </div>

        <div v-if="existeTelefone" class="text-center form-sm mt-2">
          <span
            ><b style="color: red"
              >Já existe um usuário com este Telefone cadastrado</b
            ></span
          >
        </div>

        <div class="md-form form-sm">
          <label data-error="wrong" data-success="right" for="email"
            >Email:</label
          >
          <input
            type="email"
            id="email"
            class="form-control form-control-sm validate"
            v-model="payload.email"
            @blur="existeEmailCadastrado()"
            required
          />
        </div>
        <b>ATENÇÃO!</b> É muito importante que você acesse periodicamente este
        <b style="color: red">e-mail</b> e esteja atento ao
        <b style="color: red">whatsapp do número cadastrado.</b> Serão enviados
        alertas de ofertas ou demandas de produtos de seu interesse de acordo
        com seu perfil cadastrado. <br /><br />

        <div v-if="existeEmail" class="text-center form-sm mt-2">
          <span
            ><b style="color: red"
              >Já existe um usuário com este Email cadastrado</b
            ></span
          >
        </div>

        <div class="form-check md-form form-sm">
          <input
            type="checkbox"
            id="notificacaoEmail"
            class="form-check-input validate"
            v-model="payload.notificacaoEmail"
          />
          <b>Desejo ser notificado via e-mail</b><br /><br />
        </div>

        <div class="form-check md-form form-sm">
          <input
            type="checkbox"
            id="notificacaoWhatsapp"
            class="form-check-input validate"
            v-model="payload.notificacaoWhatsapp"
          />
          <b>Desejo ser notificado via whatsapp</b><br /><br />
        </div>
        <div v-if="!payload.usuarioId">
          <div class="md-form form-sm">
            <label data-error="wrong" data-success="right" for="senha"
              >Senha:
            </label>
            <input
              type="password"
              id="senha"
              class="form-control form-control-sm validate"
              v-model="payload.senha"
              required
            />
          </div>

          <div class="md-form form-sm mb-4">
            <label
              data-error="wrong"
              data-success="right"
              for="confirmacaosenha"
              >Confirme sua senha:</label
            >
            <input
              type="password"
              id="confirmacaosenha"
              class="form-control form-control-sm validate"
              v-model="payload.confirma_senha"
              required
            />
          </div>

          <span
            >Sua senha deve conter pelo menos 08 caracteres e combinar ao menos
            uma letra, um número e um caracter especial ([@!#$%^&*()/]).</span
          >
        </div>

        <hr v-if="payload.produtor" />

        <h2 v-if="payload.produtor">Dados da Propriedade</h2>

        <div v-if="payload.produtor" class="md-form form-sm">
          <label data-error="wrong" data-success="right" for="nomePropriedade"
            >Nome da Propriedade:</label
          >
          <input
            type="text"
            id="nomePropriedade"
            class="form-control form-control-sm validate"
            v-model="payload.propriedades[0].nome"
            :required="payload.produtor"
          />
        </div>
        <br />

        <div v-if="payload.produtor" class="md-form form-sm">
          <b
            >Pelo menos UM dos três próximos campos precisa ser preenchido:
            Inscrição Estadual ou CNPJ ou DAP</b
          ><br /><br />
          <label data-error="wrong" data-success="right" for="inscricaoEstadual"
            >Inscrição Estadual:</label
          >
          <input
            type="text"
            id="inscricaoEstadual"
            class="form-control form-control-sm validate"
            v-model="payload.inscricaoEstadual"
            :required="
              payload.produtor && payload.dap == '' && payload.cnpj == ''
            "
            :minlenght="5"
          />
        </div>

        <div v-if="payload.produtor" class="md-form form-sm">
          <label data-error="wrong" data-success="right" for="cnpj"
            >CNPJ:</label
          >
          <input
            type="text"
            id="cnpj"
            class="form-control form-control-sm validate"
            v-model="payload.cnpj"
            :required="
              payload.produtor &&
              payload.inscricaoEstadual == '' &&
              payload.dap == ''
            "
            v-mask="'##.###.###/####-##'"
            @blur="existeCNPJCadastrado()"
          />
        </div>

        <div
          v-if="existeCNPJ & payload.produtor"
          class="text-center form-sm mt-2"
        >
          <span>Este CNPJ já está cadastrado no sistema</span>
        </div>

        <div v-if="payload.produtor" class="md-form form-sm">
          <label data-error="wrong" data-success="right" for="dap">DAP:</label>
          <input
            type="text"
            id="dap"
            class="form-control form-control-sm validate"
            v-model="payload.dap"
            :required="
              payload.produtor &&
              payload.inscricaoEstadual == '' &&
              payload.cnpj == ''
            "
          />
        </div>
        <br />
        <div v-if="payload.produtor" class="md-form form-sm">
          <label data-error="wrong" data-success="right" for="inicio"
            >Data de Início da atividade:</label
          >
          <input
            type="text"
            id="inicio"
            class="form-control form-control-sm validate"
            v-mask="'##/##/####'"
            v-model="payload.inicioAtividadeString"
            pattern="(0[1-9]|1[0-9]|2[0-9]|3[01])/(0[1-9]|1[012])/[0-9]{4}"
            :required="payload.produtor"
          />
        </div>

        <div v-if="payload.produtor" class="md-form form-sm">
          <label for="porte">Porte</label>
          <select
            class="form-control"
            id="porte"
            v-model="payload.porteId"
            :required="payload.produtor"
          >
            <option
              v-for="porte in portes"
              v-bind:value="porte.porteId"
              v-bind:key="porte.porteId"
            >
              {{ porte.nome }}
            </option>
          </select>
        </div>

        <div v-if="payload.produtor" class="md-form form-sm">
          <label for="municipio">Município:</label>
          <select
            class="form-control"
            id="municipio"
            v-model="payload.propriedades[0].municipioId"
            :required="payload.produtor"
          >
            <option
              v-for="municipio in municipios"
              v-bind:value="municipio.municipioId"
              v-bind:key="municipio.municipioId"
            >
              {{ municipio.nome }}
            </option>
          </select>
        </div>

        <div v-if="payload.produtor" class="md-form form-sm">
          <label data-error="wrong" data-success="right" for="bairroPropriedade"
            >Bairro:</label
          >
          <input
            type="text"
            id="bairroPropriedade"
            class="form-control form-control-sm validate"
            :required="payload.produtor"
            v-model="payload.propriedades[0].bairro"
          />
        </div>

        <div v-if="payload.produtor" class="md-form form-sm">
          <label
            data-error="wrong"
            data-success="right"
            for="complementoPropriedade"
            >Complemento:</label
          >
          <input
            type="text"
            id="complementoPropriedade"
            class="form-control form-control-sm validate"
            v-model="payload.propriedades[0].complemento"
          />
        </div>

        <div v-if="payload.produtor" class="md-form form-sm">
          <label data-error="wrong" data-success="right" for="numeroPropriedade"
            >Número:</label
          >
          <input
            type="text"
            id="numeroPropriedade"
            class="form-control form-control-sm validate"
            :required="payload.produtor"
            v-model="payload.propriedades[0].numero"
          />
        </div>

        <div v-if="payload.produtor" class="md-form form-sm">
          <label
            data-error="wrong"
            data-success="right"
            for="logradouroPropriedade"
            >Logradouro:</label
          >
          <input
            type="text"
            id="logradouroPropriedade"
            class="form-control form-control-sm validate"
            :required="payload.produtor"
            v-model="payload.propriedades[0].logradouro"
          />
        </div>

        <div v-if="payload.produtor" class="md-form">
          <i class="fas fa-user prefix grey-text"></i>
          <label data-error="wrong" data-success="right" for="lead"
            >Se desejar, insira aqui fotos da propriedade:</label
          >
          <input
            type="file"
            multiple
            label="Selecione as imagens"
            @change="adicionarImagem($event)"
          />
        </div>

        <hr v-if="payload.comprador" />

        <h2 v-if="payload.comprador">Dados da Empresa</h2>

        <div v-if="payload.comprador" class="md-form form-sm">
          <label data-error="wrong" data-success="right" for="cnpj"
            >CNPJ:</label
          >
          <input
            type="text"
            id="cnpj"
            class="form-control form-control-sm validate"
            v-model="payload.cnpj"
            :required="
              payload.comprador ||
              (payload.produtor &&
                payload.inscricaoEstadual === null &&
                payload.dap === null)
            "
            v-mask="'##.###.###/####-##'"
            value=" "
            @blur="existeCNPJCadastrado()"
          />
        </div>

        <div
          v-if="existeCNPJ & payload.comprador"
          class="text-center form-sm mt-2"
        >
          <span>Este CNPJ já está cadastrado no sistema</span>
        </div>

        <div v-if="payload.comprador" class="md-form form-sm">
          <label data-error="wrong" data-success="right" for="nomeEmpresa"
            >Razão Social:</label
          >
          <input
            type="text"
            id="nomeEmpresa"
            class="form-control form-control-sm validate"
            :required="payload.comprador"
            v-model="payload.empresas[0].nome"
          />
        </div>

        <div v-if="payload.comprador" class="md-form form-sm">
          <label
            data-error="wrong"
            data-success="right"
            for="nomeEmpresaFantasia"
            >Nome Fantasia:</label
          >
          <input
            type="text"
            id="nomeEmpresaFantasia"
            class="form-control form-control-sm validate"
            :required="payload.comprador"
            v-model="payload.empresas[0].nomeFantasia"
          />
        </div>

        <div v-if="payload.comprador" class="md-form form-sm">
          <label for="municipio">Município:</label>
          <select
            class="form-control"
            id="municipio"
            v-model="payload.empresas[0].municipioId"
            :required="payload.comprador"
          >
            <option
              v-for="municipio in municipios"
              v-bind:value="municipio.municipioId"
              v-bind:key="municipio.municipioId"
            >
              {{ municipio.nome }}
            </option>
          </select>
        </div>

        <div v-if="payload.comprador" class="md-form form-sm">
          <label data-error="wrong" data-success="right" for="bairroEmpresa"
            >Bairro:</label
          >
          <input
            type="text"
            id="bairroEmpresa"
            class="form-control form-control-sm validate"
            :required="payload.comprador"
            v-model="payload.empresas[0].bairro"
          />
        </div>

        <div v-if="payload.comprador" class="md-form form-sm">
          <label data-error="wrong" data-success="right" for="logradouroEmpresa"
            >Logradouro:</label
          >
          <input
            type="text"
            id="logradouroEmpresa"
            class="form-control form-control-sm validate"
            :required="payload.comprador"
            v-model="payload.empresas[0].logradouro"
          />
        </div>

        <div v-if="payload.comprador" class="md-form form-sm">
          <label data-error="wrong" data-success="right" for="numeroEmpresa"
            >Número:</label
          >
          <input
            type="text"
            id="numeroEmpresa"
            class="form-control form-control-sm validate"
            :required="payload.comprador"
            v-model="payload.empresas[0].numero"
          />
        </div>

        <div v-if="payload.comprador" class="md-form form-sm">
          <label
            data-error="wrong"
            data-success="right"
            for="complementoEmpresa"
            >Complemento:</label
          >
          <input
            type="text"
            id="complementoEmpresa"
            class="form-control form-control-sm validate"
            v-model="payload.empresas[0].complemento"
          />
        </div>

        <div class="md-form form-sm">
          <label data-error="wrong" data-success="right" for="termosDeUso"
            ><b>Termos de Uso e Privacidade:</b></label
          >
          <div
            align="justify"
            style="
              font-size: 13px;
              height: 100px;
              overflow: auto;
              border: 2px solid;
              padding: 6px;
            "
            v-html="termosDeUso"
          ></div>
          <!--<textarea contenteditable="true" id="termosDeUso" class="form-control form-control-sm validate" rows="5" cols="33" disabled v-html="termosDeUso"></textarea>-->
        </div>

        <div class="form-check md-form form-sm">
          <input
            type="checkbox"
            id="aceiteTermosDeUso"
            class="form-check-input validate"
            v-model="payload.aceite"
          />
          <b style="font-size: 12px">
            CONCORDO com os
            <a
              href="https://www.sebrae.com.br/Sebrae/Portal%20Sebrae/LGPD/Termo%20de%20Uso%20-%20Portal%20Revisado%2027.07.2020%20v.%201.0[178180].pdf"
              target="_blank"
              >Termos de Uso </a
            >e com a
            <a
              href="https://www.sebrae.com.br/Sebrae/Portal%20Sebrae/LGPD/Pol%C3%ADtica%20de%20Privacidade%2020200820.pdf"
              target="_blank"
              >Política de Privacidade</a
            >
            do SEBRAE</b
          >
        </div>
        <div class="text-center form-sm mt-2">
          <button
            class="btn btn-info"
            type="submit"
            :disabled="
              !payload.aceite ||
              (!payload.produtor && !payload.comprador && !payload.outros)
            "
          >
            {{ botao }}
          </button>
          <button
            hidden="true"
            id="fechar_btn_usuario"
            @click="$bvModal.hide('modal_inserir_usuario')"
          >
            Fechar
          </button>
        </div>

        <div v-if="avisoCadastrarUsuario" class="text-center form-sm mt-2">
          <span v-for="aviso in avisos" v-bind:key="aviso"
            ><b style="color: red">{{ aviso }}</b></span
          >
        </div>

        <div v-if="erroCadastrarUsuario" class="text-center form-sm mt-2">
          <span>Erro ao cadastrar usuário</span>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  municipioAPI,
  porteAPI,
  propriedadeAPI,
  usuarioAPI,
} from "@/modules/home";
import { cpf, cnpj } from "cpf-cnpj-validator";

export default {
  computed: {
    ...mapGetters(["token"]),
  },
  data() {
    return {
      titulo: "Cadastro de Usuário",
      botao: "Cadastrar",
      payload: {
        comprador: false,
        produtor: false,
        propriedades: [
          {
            nome: null,
            bairro: null,
            complemento: null,
            numero: null,
            logradouro: null,
          },
        ],
        empresas: [
          {
            nome: null,
            nomeFantasia: null,
            bairro: null,
            complemento: null,
            numero: null,
            logradouro: null,
            telefone: null,
            email: null,
          },
        ],
        inscricaoEstadual: null,
        cnpj: null,
        dap: null,
      },
      municipios: [],
      portes: [],
      showPropriedade: false,
      usarDadosUsuarioPropriedade: false,
      usarDadosUsuarioEmpresa: false,
      erroCadastrarUsuario: false,
      avisoCadastrarUsuario: false,
      avisos: [],
      imagens: null,
      existeEmail: false,
      existeTelefone: false,
      existeCPF: false,
      existeCNPJ: false,
      termosDeUso:
        '<p><strong>Para criar uma conta no Sebrae, voc&ecirc; precisa concordar com os nossos <a href="https://www.sebrae.com.br/Sebrae/Portal%20Sebrae/LGPD/Termo%20de%20Uso%20-%20Portal%20Revisado%2027.07.2020%20v.%201.0[178180].pdf" target="_blank">Termos de Uso </a> e com as nossas <a href="https://www.sebrae.com.br/Sebrae/Portal%20Sebrae/LGPD/Pol%C3%ADtica%20de%20Privacidade%2020200820.pdf" target="_blank">Pol&iacute;ticas de Privacidade</a>. De forma geral, podemos utilizar os seus dados pessoais para as seguintes finalidades:</strong></p><ol><li>Cumprir as obriga&ccedil;&otilde;es contratuais, legais e regulat&oacute;rias do SISTEMA SEBRAE em raz&atilde;o de suas atividades;</li> <li>Execu&ccedil;&atilde;o de seus Programas e presta&ccedil;&atilde;o de servi&ccedil;os;</li><li>Fomentar, desenvolver e melhorar solu&ccedil;&otilde;es para empreendedores e pequenos neg&oacute;cios;</li><li>Oferecer produtos e servi&ccedil;os que sejam do meu interesse;</li><li>Realizar pesquisas com os clientes que foram atendidos pelo SISTEMA SEBRAE;</li><li>Realizar a comunica&ccedil;&atilde;o oficial pelo SISTEMA SEBRAE ou por seus prestadores de servi&ccedil;o, por meio de quaisquer canais de comunica&ccedil;&atilde;o (telefone, e-mail, SMS, WhatsApp, etc.).</li></ol><p><strong>Em observ&acirc;ncia &agrave; Lei n&deg; 13.709/18 Lei Geral de Prote&ccedil;&atilde;o de Dados Pessoais e demais normativas aplic&aacute;veis sobre prote&ccedil;&atilde;o de Dados Pessoais. CONCORDO com os Termos de Uso e com a Pol&iacute;tica de Privacidade do SEBRAE e manifesto-me de forma informada, livre, expressa e consciente no sentido de autorizar o SEBRAE a realizar o tratamento de meus Dados Pessoais.</strong></p>',
    };
  },
  methods: {
    ...mapActions(["setToken", "setUser", "setLoading", "setAdmin"]),
    onLogin() {
      this.setLoading(true);
      this.$http
        .post("api/usuario/usuario/login", this.payload)
        .then(({ data }) => {
          this.setUser(JSON.stringify(data.user));
          this.setToken(data.accessToken);
          if (data.user.grupo.nome === "Admin") this.setAdmin(true);
          this.$http.defaults.headers.common.Authorization = `Bearer ${this.token}`;
          this.setLoading(false);
          this.payload = {};
          this.$toast("Bem Vindo, " + data.user.nome, {
            timeout: 2000,
            hideProgressBar: true,
          });
          location.reload();
        })
        .catch(({ data }) => {
          this.setLoading(false);
          this.$toast.error("Erro ao Logar com usuário", {
            timeout: 2000,
            hideProgressBar: true,
          });
        });
    },
    criarUsuario() {
      let regex =
        /^(?=.*[@!#$%^&*()/\\])(?=.*[0-9])(?=.*[a-zA-Z])[@!#$%^&*()/\\a-zA-Z0-9]{8,20}$/;
      this.payload.DataAlteracaoSenha = new Date();
      this.avisos = [];
      this.avisoCadastrarUsuario = false;
      this.erroCadastrarUsuario = false;
      if (
        this.existeEmail ||
        this.existeTelefone ||
        this.existeCPF ||
        this.existeCNPJ
      ) {
        this.avisoCadastrarUsuario = true;
        this.avisos.push("Por favor, corrija os campos informados acima");
      }
      if (!this.payload.aceite) {
        this.avisoCadastrarUsuario = true;
        this.avisos.push("Você deve aceitar os termos de uso do site");
      }
      if (
        this.payload.CPF.length >= 1 &&
        cpf.isValid(this.payload.CPF) === false
      ) {
        this.avisoCadastrarUsuario = true;
        this.avisos.push("Digite um CPF válido");
      } else if (
        ((this.payload.produtor &&
          this.payload.cnpj !== null &&
          this.payload.inscricaoEstadual == null &&
          this.payload.dap == null) ||
          (this.payload.comprador && this.payload.cnpj !== null)) &&
        cnpj.isValid(this.payload.cnpj) === false
      ) {
        this.avisoCadastrarUsuario = true;
        this.avisos.push("Digite um CNPJ válido");
      } else if (
        !this.payload.outros &&
        !this.payload.produtor &&
        this.payload.cnpj == null
      ) {
        this.avisoCadastrarUsuario = true;
        this.avisos.push("Você deve preencher o CNPJ");
      } else if (
        this.payload.produtor &&
        this.payload.cnpj == null &&
        (this.payload.dap == null || this.payload.dap.length < 2) &&
        (this.payload.inscricaoEstadual == null ||
          this.payload.inscricaoEstadual.length < 2)
      ) {
        this.avisoCadastrarUsuario = true;
        this.avisos.push(
          "Você deve preencher o CNPJ, DAP ou Inscrição Estadual"
        );
      } else if (
        this.payload.produtor &&
        this.payload.propriedades[0].nome === null
      ) {
        this.avisoCadastrarUsuario = true;
        this.avisos.push("Você deve cadastrar uma propriedade");
      } else if (
        !this.payload.usuarioId &&
        this.payload.confirma_senha !== this.payload.senha
      ) {
        this.avisoCadastrarUsuario = true;
        this.avisos.push(
          "A Senha cadastrada não confere com a Confirmação digitada"
        );
      } else if (!this.payload.usuarioId && this.payload.senha.length < 8) {
        this.avisoCadastrarUsuario = true;
        this.avisos.push("A senha deve possuir pelo menos 8 dígitos");
      } else if (
        !this.payload.usuarioId &&
        regex.test(this.payload.senha) == false
      ) {
        this.avisoCadastrarUsuario = true;
        this.avisos.push(
          "A senha não possui caracteres especiais ou tem menos de 08 dígitos."
        );
      } else {
        this.setLoading(true);
        if (this.payload.usuarioId) {
          usuarioAPI
            .update(this.payload)
            .then((resp) => {
              if (this.payload.produtor && this.imagens) {
                this.cadastrarImagensPropriedade();
              } else {
                this.setLoading(false);
              }
              this.$toast("Dados atualizados com sucesso!", {
                timeout: 2000,
                hideProgressBar: true,
              });
            })
            .catch((resp) => {
              this.setLoading(false);
            });
          // this.$toast('Dados atualizados com sucesso!', { timeout: 2000, hideProgressBar: true })
        } else {
          usuarioAPI
            .create(this.payload)
            .then((resp) => {
              if (this.payload.produtor) {
                this.cadastrarImagensPropriedade();
                document.getElementsByClassName("close")[12].click();
                this.onLogin();
              } else {
                document.getElementsByClassName("close")[12].click();
                this.onLogin();
              }
            })
            .catch((resp) => {
              this.setLoading(false);
              this.onLogin();
              // this.erroCadastrarUsuario = true
            });
        }
      }
    },
    listarMunicipios() {
      municipioAPI
        .list()
        .then((resp) => {
          this.municipios = resp.data;
        })
        .catch((resp) => {
          this.setLoading(false);
        });
    },
    listarPortes() {
      porteAPI
        .list()
        .then((resp) => {
          this.portes = resp.data;
        })
        .catch((resp) => {
          this.setLoading(false);
        });
    },
    changeProdutor() {
      console.log(" this.payload: ", this.payload);
      console.log(" this.payload: ", this.payload.propriedades);

      // if (this.payload.produtor) {
      //   this.showPropriedade = true;
      // } else {
      //   this.showPropriedade = false;
      //   this.payload.propriedades[0] = {};
      // }
    },
    changeUsarDadosUsuarioPropriedade() {
      console.log("usarDadosUsuarioPropriedade: ", usarDadosUsuarioPropriedade);
      if (this.usarDadosUsuarioPropriedade) {
        this.payload.propriedades = [];
        this.payload.propriedades.push({
          municipioId: this.payload.municipioId,
          bairro: this.payload.bairro,
          complemento: this.payload.complemento,
          numero: this.payload.numero,
          logradouro: this.payload.logradouro,
        });
      }
    },
    changeUsarDadosUsuarioEmpresa() {
      if (this.usarDadosUsuarioEmpresa) {
        this.payload.empresas[0].municipioId = this.payload.municipioId;
        this.payload.empresas[0].bairro = this.payload.bairro;
        this.payload.empresas[0].complemento = this.payload.complemento;
        this.payload.empresas[0].numero = this.payload.numero;
        this.payload.empresas[0].logradouro = this.payload.logradouro;
      }
    },
    adicionarImagem(event) {
      this.imagens = event.target.files;
    },
    cadastrarImagensPropriedade() {
      const formData = new FormData();

      for (let i = 0; i < this.imagens.length; i++) {
        formData.append("imagens", this.imagens[i]);
      }

      formData.append("nome", this.payload.propriedades[0].nome);
      formData.append("nomeUsuario", this.payload.nome);

      propriedadeAPI
        .cadastrarImagens(formData)
        .then((resp) => {
          if (!this.payload.usuarioId) {
            this.onLogin();
          }
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
        });
    },
    existeEmailCadastrado() {
      this.setLoading(true);
      usuarioAPI
        .existeEmail(this.payload)
        .then((resp) => {
          this.existeEmail = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
        });
    },
    existeTelefoneCadastrado() {
      this.setLoading(true);
      usuarioAPI
        .existeTelefone(this.payload)
        .then((resp) => {
          this.existeTelefone = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
        });
    },
    existeCPFCadastrado() {
      this.setLoading(true);
      usuarioAPI
        .existeCPF(this.payload)
        .then((resp) => {
          this.existeCPF = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
        });
    },
    existeCNPJCadastrado() {
      if (this.payload.cnpj.length > 0) {
        this.setLoading(true);
        usuarioAPI
          .existeCNPJ(this.payload)
          .then((resp) => {
            this.existeCNPJ = resp.data;
            this.setLoading(false);
          })
          .catch((resp) => {
            this.setLoading(false);
          });
      }
    },
  },
  created() {
    this.listarMunicipios();
    this.listarPortes();
  },
  mounted() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "SET_USUARIO") {
        console.log("mutation.type : ", mutation.type);
        console.log("mutation.payload: ", mutation.payload);
        this.payload = mutation.payload;

        this.payload.propriedades =
          this.payload.propriedades.length > 0
            ? this.payload.propriedades
            : [
                {
                  nome: null,
                  bairro: null,
                  complemento: null,
                  numero: null,
                  logradouro: null,
                },
              ];
        this.payload.nascimentoString =
          mutation.payload.nascimento.substring(8, 10) +
          "/" +
          mutation.payload.nascimento.substring(5, 7) +
          "/" +
          mutation.payload.nascimento.substring(0, 4);
        this.payload.CPF = mutation.payload.cpf;
        if (mutation.payload.empresas) {
          if (mutation.payload.empresas[0] !== undefined) {
            this.payload.comprador = true;
          }
        }
        if (mutation.payload.propriedades) {
          if (mutation.payload.inicioAtividade !== undefined) {
            this.payload.produtor = true;
            console.log("this.payload: ", this.payload);
            console.log(
              "this.payload.inicioAtividadeString: ",
              this.payload.inicioAtividadeString
            );
            this.payload.inicioAtividadeString =
              mutation.payload.inicioAtividade.substring(8, 10) +
              "/" +
              mutation.payload.inicioAtividade.substring(5, 7) +
              "/" +
              mutation.payload.inicioAtividade.substring(0, 4);
          }
        }
        this.payload.confirma_senha = mutation.payload.senha;
        this.payload.cnpj = mutation.payload.cnpj;
        this.payload.complemento = mutation.payload.complemento;
        this.botao = "Salvar Alterações";
        this.titulo = "Editar Cadastro de Usuário";
      }
    });
  },
};
</script>
